exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SpendingStructureTable_nestedLevelZero_2kJ7 {\n  margin-left: 0;\n}\n\n.SpendingStructureTable_nestedLevelOne_24Cp {\n  margin-left: 15px;\n}\n\n.SpendingStructureTable_nestedLevelTwo_2jfD {\n  margin-left: 30px;\n}\n\n.SpendingStructureTable_sumCell_1Mir {\n  white-space: nowrap;\n}\n", ""]);

// exports
exports.locals = {
	"nestedLevelZero": "SpendingStructureTable_nestedLevelZero_2kJ7",
	"nestedLevelOne": "SpendingStructureTable_nestedLevelOne_24Cp",
	"nestedLevelTwo": "SpendingStructureTable_nestedLevelTwo_2jfD",
	"sumCell": "SpendingStructureTable_sumCell_1Mir"
};